import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isAuthSessionValid, isSuperAdmin } from '../utils/authSession';

export default function RequireSuperAdmin() {
  if (!isAuthSessionValid()) {
    return <Navigate to="/login" replace />;
  }

  if (!isSuperAdmin()) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
